import type { DeepString } from "@/lib/i18n";

/**
 * WShopPromotionalProducts - stringi chrome okna (naglowek + CTA).
 * Etykiety kafelka (badge, status, cena, "do koszyka") pochodza z
 * `<ProductCard />` (wspoldzielony i18n `components/ui/ProductCard`).
 */
export const pl = {
  title: "Promocje",
  showAll: "Zobacz wszystkie",
  noProducts: "Brak produktów w promocji.",
} as const;

export type WShopPromotionalProductsTranslations = DeepString<typeof pl>;
